import Vue from 'vue'
import configs from '@/config'

let resource = null
// NOTE: seperate 2 type of api:
// + api: personal folder
// + api: for team folder
const actions = {
  getFolders: {
    method: 'GET',
    url: `${configs.baseUrl}/api/folder/`,
  },
  createFolder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/folder`,
  },
  updateFolderById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/folder/{folderId}`,
  },
  removeFolderById: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/folder/{folderId}`,
  },
  // Team:
  getTeamFolders: {
    method: 'GET',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/folder`,
  },
  createTeamFolder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/folder`,
  },
  editTeamFolderById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/folder/{folderId}`,
  },
  removeTeamFolderById: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/folder/{folderId}`,
  },
  moveTeamPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/account-folder/{accountId}/presentation/move-to-folder`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getFolders = async (params) => {
  const res = await resource.getFolders(params)
  return res.body.folders
}

const createFolder = async (params) => {
  const res = await resource.createFolder(params)

  return {
    code: res.body.code,
    folder: res.body.folder,
  }
}

const updateFolderById = (folderId, params) => {
  return resource.updateFolderById({ folderId }, params)
}

const removeFolderById = (folderId) => {
  return resource.removeFolderById({ folderId })
}
// Team Folder..
const getTeamFolders = async (params) => {
  const { accountId } = params
  const result = await resource.getTeamFolders({ accountId }, params)
  return result.body.folders
}

const createTeamFolder = async (accountId, params) => {
  const res = await resource.createTeamFolder({ accountId }, params)
  return {
    code: res.body.code,
    folder: res.body.folder,
  }
}

const editTeamFolderById = async (accountId, folderId, params) => {
  const res = await resource.editTeamFolderById({ accountId, folderId }, params)
  return {
    code: res.body.code,
    folder: res.body.folder,
  }
}
const removeTeamFolderById = async (accountId, folderId, params) => {
  const res = await resource.removeTeamFolderById({ accountId, folderId }, params)
  return res.body
}

const moveTeamPresentation = async (accountId, params) => {
  const res = await resource.moveTeamPresentation({ accountId }, params)
  return res.body
}
export default {
  initResource,
  getFolders,
  createFolder,
  updateFolderById,
  removeFolderById,
  getTeamFolders,
  createTeamFolder,
  editTeamFolderById,
  removeTeamFolderById,
  moveTeamPresentation,
}
